<ng-container *ngIf="orders">
  <div class="my-orders--container animate__animated animate__fadeIn">
    <ng-container *ngFor="let order of orders">
      <div class="card shadow-sm">
        <app-my-account-order [order]="order"></app-my-account-order>
      </div>
    </ng-container>
  </div>
</ng-container>
